import React from "react";
import {
  TextField,
  Button,
} from "@mui/material";

import { useState } from "react";

const orderTypes = {
  person: 'person',
  organization: 'organization'
}

const OrderDetail = ({type, onSubmit}) => {
  const [name, setName] = useState("");
  const [register, setRegister] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const getTitle = () => (type === orderTypes.person ? "Таныг" : "Байгууллага")
  const getText = () => (type === orderTypes.person ? "Хэрэглэгчийн" : "Байгууллагын")

  return (
    <>
      <div className="account-content px-4 px-sm-6">
        <p className="font-size-20 font-weight-bold text-center">
          {getTitle()} таних мэдээлэл
        </p>
        <TextField
          className="mb-3 w-100"
          label={`${getText()} нэр`}
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          className="mb-3 w-100"
          label={`${getText()} регистр`}
          variant="outlined"
          value={register}
          onChange={(e) => setRegister(e.target.value)}
        />
        <div className="row mb-3">
          <div className="col-6">
            <TextField
              className="w-100"
              label="И-мэйл"
              variant="outlined"
              value={email}
              type="email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="col-6">
            <TextField
              className="w-100"
              label="Утасны дугаар"
              variant="outlined"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="dialog-footer">
        <Button
          onClick={onSubmit}
          className="bg-primary btn-bordered w-100"
          variant="contained"
          disableElevation
        >
          <span className="mx-2">Үргэлжлүүлэх</span>
        </Button>
      </div>
    </>
  );
};

export default OrderDetail;
